let mockNotifications = [
  {
    id: 1,
    // name: 'Welcome Email',
    nameEn:'chirag',
    nameAr: 'شيراج',
    code: '001',
    subjectEn: 'Welcome to the Company',
    subjectAr: 'Welcome to the Company',
    bodyEn: 'Hello, welcome aboard!',
    bodyAr: 'مرحباً، أهلاً بك!',
    typeID: 'delay',
    schedule: 'Daily',
    assignTypes:[{toAssignType:"" , toTarget :""}],
    ccAssignTypes:[{toAssignType:"" , toTarget :""}],
    notificationKind: 'Email',
    dailyScheduleType: 1,
    notificationInterval: 1,
    scheduleDuration: '1 day',
    toTypeID1: 1,
    toID1: 101,
    toTypeID2: 2,
    toID2: 201,
    ccList: [
      {
        id: 1,
        ccTypeID: 2,
        ccID: 301,
        TargetEmployeesTypeName: 'Manager',
        ccName: 'John Doe',
      },
    ],
  },
  {
    id: 2,
    // name: 'Weekly Summary',
     nameEn:'Weekly Summary',
    nameAr: 'الملخص الأسبوعي',
    code: '005',
    subjectEn: 'Your Weekly Summary',
    subjectAr: 'Your Weekly Summary',
    bodyEn: 'Here is your summary for the week.',
    bodyAr: 'إليك ملخص الأسبوع.',
    typeID: 'absent',
    schedule: 'Weekly',
    assignTypes:[{toAssignType:"" , toTarget :""}],
    ccAssignTypes:[{toAssignType:"" , toTarget :""}],
    notificationKind: 'SMS',
    notificationInterval: 7,
    scheduleDuration: '7 days',
    toTypeID1: 1,
    toID1: 102,
    toTypeID2: 2,
    toID2: 202,
    ccList: [],
  },
  {
    id: 3,
    // name: 'Holiday Alert',
    nameEn:'Holiday Alert',
    nameAr:'تنبيه العطلة',
    code:"02",

    subjectEn: 'Upcoming Holiday Notification',
    subjectAr: 'Upcoming Holiday Notification',
    bodyEn: 'Please note the upcoming holiday.',
    bodyAr: 'يرجى ملاحظة العطلة القادمة.',
    typeID: 'violation',
    schedule: 'Monthly',
    assignTypes:[{toAssignType:"" , toTarget :""}],
    ccAssignTypes:[{toAssignType:"" , toTarget :""}],
    notificationKind: 'Email',
    notificationInterval: 30,
    scheduleDuration: '1 month',
    toTypeID1: 1,
    toID1: 103,
    toTypeID2: 2,
    toID2: 203,
    ccList: [],
  },
  {
    id: 4,
    nameEn: 'Policy Update',
    nameAr: 'تحديث السياسة',
    subjectEn: 'Company Policy Updated',
    subjectAr: 'Company Policy Updated',
    bodyEn: 'Please review the updated company policy.',
    bodyAr: 'يرجى مراجعة سياسة الشركة المحدثة.',
    typeID: 'violation',
    schedule: 'Monthly',
    assignTypes:[{toAssignType:"" , toTarget :""}],
    ccAssignTypes:[{toAssignType:"" , toTarget :""}],
    notificationKind: 'Email',
    notificationInterval: 0,
    scheduleDuration: 'N/A',
    toTypeID1: 1,
    toID1: 104,
    toTypeID2: 2,
    toID2: 204,
    ccList: [],
  },
  {
    id: 5,
    nameEn: 'Maintenance Notice',
    nameAr:'إشعار الصيانة',
    code:'01',
    subjectEn: 'System Maintenance',
    subjectAr: 'System Maintenance',
    bodyEn: 'Scheduled system maintenance on Friday.',
    bodyAr: 'الصيانة المجدولة للنظام يوم الجمعة.',
    typeID: 'absent',
    schedule: 'Weekly',
    assignTypes:[{toAssignType:"" , toTarget :""}],
    ccAssignTypes:[{toAssignType:"" , toTarget :""}],
    notificationKind: 'SMS',
    notificationInterval: 7,
    scheduleDuration: '1 week',
    toTypeID1: 1,
    toID1: 105,
    toTypeID2: 2,
    toID2: 205,
    ccList: [
      {
        id: 1,
        ccTypeID: 2,
        ccID: 302,
        TargetEmployeesTypeName: 'Admin',
        ccName: 'Jane Smith',
      },
    ],
  },
];

let idCounter = mockNotifications.length + 1;

const NotificationAPI = {
  getAll: async () =>
    new Promise((resolve) => {      
      setTimeout(
        () => resolve({ data: { data: [...mockNotifications] } }),
        300
      );
    }),
  add: async (data) =>
    new Promise((resolve) => {
      const newItem = { ...data, id: idCounter++ };
      mockNotifications.push(newItem);
      setTimeout(() => resolve({ data: { data: newItem } }), 300);
    }),
  update: async (id, data) =>
    new Promise((resolve) => {
      const index = mockNotifications.findIndex((n) => n.id === id);
      if (index !== -1)
        mockNotifications[index] = { ...mockNotifications[index], ...data };
      setTimeout(
        () => resolve({ data: { data: mockNotifications[index] } }),
        300
      );
    }),
  delete: async (ids) =>
    new Promise((resolve) => {
      const idsToDelete = Array.isArray(ids) ? ids : [ids];
      mockNotifications = mockNotifications.filter(
        (n) => !idsToDelete.includes(n.id)
      );
      setTimeout(() => resolve({ data: { deletedIds: idsToDelete } }), 300);
    }),
};

export default NotificationAPI;
